<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/bank")
          i.fa.fa-landmark
          span.ml-1 {{ $t("ui.bank") }}
      b-breadcrumb-item
        router-link(to="/bank/bankMember")
          i.fas.fa-landmark
          span.ml-1 {{ $t("ui.bank_member") }}

  .row
    .col-md-12
      .form-row
        .col-lg-3.col-md-3.mb-1
          b-form-radio-group(
            buttons
            v-model="filterBy"
            size="sm"
            button-variant="outline-info"
            style="width: 100%;"
            )
            b-form-radio(value="account_id") {{ $t("ui.account_id") }}
            b-form-radio(value="bank_acc_no") {{ $t("ui.bank_acc_no") }}
        .col-lg-4.col-md-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-magnifier
            DebounceInput(required autofocus type="text" v-model="search" @enter="getBankMbmList(true)")
        .col-lg-5.col-md-5.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getBankMbmList(true)"
            variant="success"
            size="sm"
            )

  .row
    .col-md-12
      .card
        .card-header.p-2.bg-gradient-light
        .card-body.p-1
          .row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          .row
            .col-md-12
              .table-responsive.mb-0
                table.table.b-table.c-table
                  thead
                    tr
                      //- th(width="3%")
                      //-   .text-center
                      //-     span #
                      //- th.sortable(width="160px" @click="sortOrder('account_id')")
                      //-   span {{ $t('ui.account_id') }}
                      //-   i(:class="changeSortKey('account_id')")
                      th.sortable(width="160px" @click="sortOrder('bank_acc_no')")
                        span {{ $t("ui.bank_acc_no") }}
                        i(:class="changeSortKey('bank_acc_no')")
                      th.sortable(width="160px" @click="sortOrder('bank_acc_holder')")
                        span {{ $t("ui.bank_acc_holder") }}
                        i(:class="changeSortKey('bank_acc_holder')")
                      th
                        span {{ $t("ui.bank_name") }}
                      th.text-center.sortable(width="60px" @click="sortOrder('status')")
                        span {{ $t("ui.status") }}
                        i(:class="changeSortKey('status')")
                      th(width="60px")
                        .text-center
                          span {{ $t("ui.action") }}
                      th(width="75px")
                        .text-center
                          span {{ $t("ui.is_default") }}
                      //- th(width="13%")
                      //-   .text-right
                      //-     span {{ $t("ui.created_date") }}
                  tbody
                    tr(v-if="bankMbmList.length == 0")
                      td(colspan="9").text-center
                        span.text-zero {{ $t('message.no_records') }}
                    tr(v-for="(item, index) in bankMbmList" :class="$helpers.rowClassBit(item.status)")
                      //- td
                      //-   .text-center
                      //-     span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      //- td
                      //-   .text-left
                      //-     span {{ item.account_id }}
                      td
                        .text-left
                          span {{ item.bank_acc_no }}
                      td
                        .text-left
                          span {{ item.bank_acc_holder }}
                      td
                        .text-left
                          span {{ item.bank_name }}
                      td
                        .d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.mb-0
                            input.switch-input(type="checkbox" v-model="item.status" @change="changedBankMbmStatus(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                      td
                        .d-flex.align-items-center.justify-content-start
                          b-link.action-item.fa.fa-edit.text-primary.action-secondary(
                            href="javascript:;"
                            :title="$t('ui.edit')"
                            @click="onEdit(item)"
                            )
                      td
                        .text-center
                          span
                            i(:class="{'fas fa-check text-info': item.is_default, 'fas fa-times text-warning': !item.is_default  }")
                      //- td
                      //-   .text-right
                      //-     span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD HH:mm:ss') }}
    editbankmember(ref="editbankmember" :item="editSelectedBankMember" @clicked="afterEditBankMember" @failed="handleFailed")

  #end-report.mt-3
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editbankmember from "@/components/bank/editBankMember.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editbankmember
  },
  data: () => ({
    loading: false,
    bankMbmList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBankMember: null,
    sortKey: "account_id",
    sortType: "asc",
    filterBy: "account_id"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    dateRange() {
      return [this.$moment(this.$store.getters.dateRange[0]), this.$moment(this.$store.getters.dateRange[1])];
    }
  },
  mounted() {},
  methods: {
    sortOrder(key) {
      if (this.sortKey == key) this.sortType = this.sortType == "asc" ? "desc" : "asc";
      else {
        this.sortKey = key;
        this.sortType = "asc";
      }
      this.getBankMbmList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key) return "fas fa-sort";
      else if (this.sortKey == key && this.sortType == "asc") return "fa fa-sort-up";
      else if (this.sortKey == key && this.sortType == "desc") return "fa fa-sort-down";
    },
    onEdit(e) {
      this.editSelectedBankMember = e;
      this.$refs.editbankmember.$refs.editBankMember.show();
    },
    afterEditBankMember(item) {
      this.getBankMbmList();
      this.$helpers.showDialog(this.$t("ui.edit_bank_member"), this.$t("message.success"), "success");
    },
    getBankMbmList(isSearch) {
      if (this.search.trim() != "") {
        if (isSearch) this.currentPage = 1;

        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username
        };

        args["page_number"] = parseInt(this.currentPage);
        args["page_size"] = this.getPageSize;
        args["sort_key"] = this.sortKey;
        args["sort_type"] = this.sortType;
        args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
        args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";

        if (this.search.trim() != "") {
          if (this.filterBy == "account_id") {
            args["member_id"] = this.search.trim();
          } else if (this.filterBy == "bank_acc_no") {
            args["bank_acc_no"] = this.search.trim();
          }
        }
        this.loading = true;
        xhr
          .doRequest(args, xhr.ACCOUNT.memberBankList)
          .then(res => {
            this.loading = false;
            this.feedback.success = res.success;
            this.feedback.status = res.status;

            if (this.feedback.success == true) {
              this.bankMbmList = res.data.bank_list;
              this.totalRow = this.bankMbmList.length > 0 ? this.bankMbmList[0].totalrows : 0;
            } else {
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          })
          .catch(res => {
            this.loading = false;
            if (res.status.toLowerCase() == "nochanges") {
            } else {
              this.feedback.success = false;
              this.feedback.status = res.status;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          });
      } else {
        this.totalRow = 0;
        this.bankMbmList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.searchCriteriaRequired"), "error");
      }
    },
    changedBankMbmStatus(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_bank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankMbmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBankMbmStatus(item, status) {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        member_id: item.account_id,
        bank_id: item.bank_id,
        bank_acc_no: item.bank_acc_no,
        new_status: status
      };
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.updateMemberBankStatus)
        .then(res => {
          console.log(res);
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;

          if (this.feedback.success == true) {
            item.status = status;
            this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
          } else {
            if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        })
        .catch(res => {
          console.log(res);
          this.loading = false;
          if (res.status.toLowerCase() == "nochanges") {
          } else {
            this.feedback.success = false;
            this.feedback.status = res.status;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        });
    },
    changedPageSize(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getBankMbmList(true);
    },
    changedPage(pageNo) {
      this.currentPage = pageNo;
      this.getBankMbmList();
    },
    handleFailed(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
